import {dialogOpen} from "reducers/dialog/actions";

export const dialog = (tr, prosemirror) =>
  prosemirror.dispatch.toRedux(dialogOpen(tr.dialog, tr.data, tr.state));
